import React from 'react';
import { Link } from 'operation-diameter';

export default {
  title: 'How would you like to proceed?',
  personalGuarantors: {
    title: 'Personal Guarantors',
    description:
      'The following shareholders are required to sign a personal guarantee. To proceed with your offer, please confirm the full name (as it appears on their ID) and personal email address of each guarantor. You will receive your guarantee via email.',
    label: {
      fullName: 'Confirmed full name',
      email: 'Email address'
    },
    modal: {
      heading: 'Confirm details for {{name}}',
      nameDescription:
        'Please confirm the guarantor’s full name as it appears on their ID',
      emailDescription: 'Please confirm the guarantor’s personal email address',
      label: {
        firstName: 'First name',
        middleNames: 'Middle names (optional)',
        lastName: 'Last name',
        emailAddress: 'Email address',
        updateDetails: 'Update details'
      }
    }
  },
  debenture: {
    subtitle: 'Your business is eligible for a Debenture',
    description: 'Key facts about a Debenture:',
    list: () => [
      'Secured against the business, so no personal liability.',
      'Choosing this option will change your total cost.'
    ],
    footer: () => (
      <>
        Please get in touch with your Account Manager to talk through this
        option. You can call us on{' '}
        <Link href='tel:0800 048 2467'>0800 048 2467</Link> or email us at{' '}
        <Link href='mailto:credit@fundingcircle.com'>
          credit@fundingcircle.com
        </Link>
      </>
    )
  },
  radio: {
    legend: 'How would you like to proceed?',
    debenture: () => (
      <>
        Don’t want any personal liability? Discuss an <b>alternative option</b>
      </>
    ),
    personalGuarantee: () => (
      <>
        Progress your offer by signing a <b>personal guarantee</b>
      </>
    )
  },
  debentureOffer: {
    title: 'Your offer requires a debenture against the business',
    paragraph: 'We will send you a document to be signed by a company director.'
  },
  personalGuaranteeCard: {
    title: 'Personal Guarantee'
  }
};
